<template>
	<div>
		<Form ref="form" :model="data" :label-width="85" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="12">
				<FormItem label="用户id：" prop="userLoginId" label-for="userLoginId">
					<Input v-model="data.userLoginId" placeholder="请输入" element-id="userLoginId" />
				</FormItem>
				</Col>

				 

                <Col  :span="12" class="ivu-text-right">
				<!-- <Col  v-bind="grid" class="ivu-text-right"> -->
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>
			</Row>
		</Form>

		<Table :columns="columns1" :data="data1">
			<template slot="action" slot-scope="{ row, index }">
				 
				<Button type="success" ghost size="small" @click="passwordInit(index)">密码重置</Button>
			</template>

		</Table>
        
		<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage" show-total
			show-elevator next-text="下一页" />
	</div>
</template>
<script>
	//let base64image = '';
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		ifValid :'1'
	};
	import {
		getUserInfoList,resetUserPwd,
	} from '@/network/index.js';
	
	 
	export default {
		components: {
			 
		},
		data() {
			return {
				columns1: [{
						title: '用户id',
						key: 'userLoginId',
						fixed: 'left',
						width: 150,
					},
					{
						title: '昵称',
						key: 'otherName',
						fixed: 'left',
						width: 100,

					},
					{
						title: '密码',
						key: 'userPassword',
						width: 150,
						ellipsis: true,
						tooltip: true,
					},
					{
						title: '邮箱',
						key: 'userEmail',
						width: 150,
						ellipsis: true,
						tooltip: true,
					},
					{
						title: '注册时间',
						key: 'createTime',
						width: 200,
					},
					 
					{
						title: '是否有效',
						key: 'ifValid',
						width: 100,
					},
		 
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						fixed: 'right',
					},


				],

				data1: [],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,
				modal1: false,
				//base64image,
				submitting: true,
				 
				//如下是查询条件的
				grid: {
					xl: 8,
					lg: 8,
					md: 12,
					sm: 24,
					xs: 24
				},


				data: {
					userLoginId: null,
					userType: null,
					submitStatus: null,
					ifValid: null,

				},
				 
			}
		},
		created() {
			this.initData(paramter);

		},
		computed: {



		},
		methods: {
		 
 

			//翻页 页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData(paramter)
			},

			//初始化用户信息 
			initData(paramter) {
	 
				getUserInfoList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								userLoginId: res.data.obj.dataList[i].userLoginId,
								otherName: res.data.obj.dataList[i].otherName,
								userEmail: res.data.obj.dataList[i].userEmail,
								userPassword: res.data.obj.dataList[i].userPassword,
								createTime: res.data.obj.dataList[i].createTime,
								ifValid: res.data.obj.dataList[i].ifValid,
							});
						}

					})
					.catch(error => {});
			},


			//查询提交
			handleSubmit() {
				let paramter = {
					userLoginId: this.data.userLoginId,
 
				};

				this.initData(paramter);

			},
			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
			},

			//用户密码重置
			passwordInit(index) {
				 
				 let paramter = {
				 	userLoginId: this.data1[index].userLoginId,
				 };
				 resetUserPwd(paramter).then(res => {
				 		if(res.success==true){
				 			this.$Message.success('密码初始化成功!');
				 		 
				 		}else{
				 			 
				 			this.$Message.error('初始化失败请联系研发！');
				 		}
				 	})
				 	.catch(error => {});
				 
				 
				 
				 
			 

			},


			 




		},



	}
</script>

<style lang="scss" scoped>
	
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}

	#head-logo {
		width: 150px;
		height: 150px;
		border-radius: 3px; //添加圆角
		//position: relative;
		//left: 300px;

	}

	
</style>
